import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { DomainMarketLangState } from '../../states/domain-market-lang.state';
import { Domain, Language, Market } from '../../models/dataref.model';
import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Resolver responsible for pre-fetching and resolving data required for the Comment feature.
 * It retrieves data like domains, markets, languages, comment reasons, and comment statuses.
 *
 * This resolver ensures that when a route is activated, the necessary reference data has been loaded.
 */

export interface PackState {
  domains: Domain[];
  markets: Market[];
  languages: Language[];
}
export const packDataResolver: ResolveFn<PackState> = (): Observable<PackState> => {
  const domainMarketLangStateService = inject(DomainMarketLangState);
  return domainMarketLangStateService.getCurrentState().pipe(
    take(1),
    switchMap((currentState: PackState) => {
      if (currentState.domains && currentState.domains.length > 0) {
        return of(currentState);
      }
      return domainMarketLangStateService.loadData();
    })
  );
};
